// 工单相关 API
import httpUtil from '@/utils/axios'

export const TicketsAPI = {
  create: (payload) => httpUtil.post('/tickets', payload),
  submitPublic: (payload) => httpUtil.post('/tickets/public/submit', payload),
  submitDummy: () => httpUtil.post('/tickets/public/submit/dummy'),
  getAll: (params = {}) => httpUtil.get('/tickets', params),
  getPending: (params = {}) => httpUtil.get('/tickets/pending', params),
  getMyTickets: () => httpUtil.get('/tickets/my-tickets'),
  getAssignedToMe: () => httpUtil.get('/tickets/assigned-to-me'),
  getById: (id) => httpUtil.get(`/tickets/${id}`),
  deleteById: (id) => httpUtil.delete(`/tickets/${id}`),
  getLogs: (id) => httpUtil.get(`/tickets/${id}/logs`),
  getCategoryStats: (params = {}) => httpUtil.get('/tickets/stats/categories', params),
  getDailyOrderStats: (params = {}) => httpUtil.get('/tickets/stats/daily-orders', params),
  getTimelinessStats: (params = {}) => httpUtil.get('/tickets/stats/timeliness', params),
  getPartReplacements: (id) => httpUtil.get(`/tickets/${id}/part-replacements`),
  getPartStats: () => httpUtil.get('/tickets/part-stats'),
  addPartReplacement: (id, payload) => httpUtil.post(`/tickets/${id}/part-replacements`, payload),
  removePartReplacement: (id, partReplacementId) => httpUtil.delete(`/tickets/${id}/part-replacements/${partReplacementId}`),
  getFollowups: (id) => httpUtil.get(`/tickets/${id}/followups`),
  addFollowup: (id, payload) => httpUtil.post(`/tickets/${id}/followups`, payload),
  uploadFollowupImage: (file, onProgress) => httpUtil.upload('/tickets/followup-images', file, onProgress),
  assign: (id, technicianId) => httpUtil.put(`/tickets/${id}/assign/${technicianId}`),
  updateStatus: (id, status) => httpUtil.put(`/tickets/${id}/status`, {}, { params: { status } }),
  addNotes: (id, notes) => httpUtil.put(`/tickets/${id}/notes`, {}, { params: { notes } }),
  adminUpdate: (id, payload) => httpUtil.put(`/tickets/${id}/admin-update`, payload),
  technicianConfirm: (id, payload) => httpUtil.put(`/tickets/${id}/technician-confirm`, payload),
  exportExcel: () => httpUtil.download('/tickets/export/excel', 'work_orders.xlsx'),
  exportWorkOrders: (params = {}) => httpUtil.download('/tickets/export/work-orders', 'work_orders.xlsx', params),
  exportProcessLogs: (params = {}) => httpUtil.download('/tickets/export/process-logs', 'work_order_process_logs.xlsx', params),
  exportStatisticsRanking: (params = {}) => httpUtil.download('/tickets/export/statistics-ranking', 'statistics_category_ranking.xlsx', params)
}

export default TicketsAPI
